<div class="{{localService.selectedLanguageCode}}"
  *ngIf="localService.languageContent && localService.languageContent.access">
  <app-popup-header title="{{localService.languageContent.access.header}}"></app-popup-header>
  <div class="modal-body modal-body-no-flexible-height">
    <div class="row">
      <div class="col-md-12">
        <ngx-select [(ngModel)]="data.v5" [optionValueField]="'key'" [optionTextField]="'value'" [items]="accessTypes"
          placeholder="{{localService.languageContent.access.access_type}}" [noAutoComplete]="true">
        </ngx-select>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <br />
        <ngx-select [(ngModel)]="data.v2" [optionValueField]="'key'" [optionTextField]="'value'" [items]="accessRanges"
          placeholder="{{localService.languageContent.access.access_range}}" [noAutoComplete]="true"
          (select)="onAccessRangeSelect()">
        </ngx-select>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <br />
        <app-global-locations *ngIf="data.v2 != '' && data.v2 != '1'" [isVertical]="true"
          [maxLevelLimit]="data.v2 == '2' ? 1 : (data.v2 == '3' ? 2 : (data.v2 == '4' ? 3 : 4))"
          (onChanged)="onLocationSelected($event)"></app-global-locations>
      </div>
    </div>
  </div>
  <div class="modal-footer modal_footer_message" *ngIf="message != ''">
    <span [ngStyle]="{'color': isRedAlert ? 'orangered' : 'darkgreen' }">{{message}}</span>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary"
      (click)="onPopupSave()">{{localService.languageContent.common.save}}</button>
  </div>
</div>